document.addEventListener('DOMContentLoaded', function () {
  const jsonEl = document.querySelector('[data-fl-variant-meta-json]');
  if (!jsonEl) return;

  let variantMeta = {};

  try {
    variantMeta = JSON.parse(jsonEl.textContent);
  } catch (error) {
    return;
  }

  function getSelectedVariantId() {
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;

    return null;
  }

  function updateMetaText(selector, value) {
    document.querySelectorAll(selector).forEach(function (item) {
        const valueEl = item.querySelector('.flMetaValue');

        if (value) {
        item.style.display = '';
        if (valueEl) valueEl.textContent = value;
        } else {
        item.style.display = 'none';
        if (valueEl) valueEl.textContent = '';
        }
    });
  }

  function updateVariantMetafields() {
    const variantId = getSelectedVariantId();
    if (!variantId || !variantMeta[variantId]) return;

    updateMetaText('[data-fl-pack-size]', variantMeta[variantId].pack_size);
    updateMetaText('[data-fl-country-origin]', variantMeta[variantId].country_of_origin);
  }

  document.addEventListener('change', function () {
    setTimeout(updateVariantMetafields, 100);
  });

  document.addEventListener('click', function () {
    setTimeout(updateVariantMetafields, 150);
  });

  updateVariantMetafields();
});